import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationScreens,
  simulationSearch,
  simulationSimulateScreen,
} from '@/modules/simulation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Simular no caminho do legado (`router.tsx:1293-1298`), com `CreditNote:Read` herdado de `/ccb`. Arquivo leve
// (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/simular/')({
  validateSearch: simulationSearch,
  staticData: { screen: simulationSimulateScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationScreens, 'SimulateRouteScreen'),
});
